export const isLocationEqualRoute = (location: string, route: string) => {
  const [, ...locationRoute] = location.split('/')
  const [, ...routeRoute] = route.split('/')

  return locationRoute.join('/') === routeRoute.join('/')
}
